import { render } from "./ServiceRow.vue?vue&type=template&id=37d85a60&ts=true"
import script from "./ServiceRow.vue?vue&type=script&lang=ts"
export * from "./ServiceRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__